var map = {
	"./Kiftavie.svg": "c1c5",
	"./btn_back.svg": "bace",
	"./btn_down.svg": "7913",
	"./btn_menu.svg": "ee26",
	"./btn_settings.svg": "dda6",
	"./cloud.svg": "99fd",
	"./focus_dream.svg": "ec70",
	"./focus_health.svg": "6ee7",
	"./focus_menu.svg": "906a",
	"./focus_personnal.svg": "717f",
	"./focus_right.svg": "b3c6",
	"./focus_school.svg": "fcbf",
	"./focus_selfdone.svg": "96cb",
	"./focus_settings.svg": "074c",
	"./focus_social.svg": "cefa",
	"./focus_work.svg": "fc68",
	"./fulltown.svg": "35b2",
	"./fulltown_animated.svg": "c26c",
	"./fulltown_background.svg": "51d6",
	"./logo-pepsra.png": "11a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";